import graphqlRequest from "Services/assignment/assignmentRequest";
import {ENTITY_TYPE} from "Services/assignment/constants";
import ADD_ASSIGNMENT from "./addAssignmentGraphql";
import {cleanManifest} from "Services/assignment/manifest";
import moment from "moment";

/**
 * creates a new assignment instance for a student entity
 * @param assignment {object} - assignment to be created for the student
 * @param studentId {string}
 * @param isBilingual {boolean} - student's isESL setting
 * @returns {Promise<*>}
 */
export async function addAssignmentForStudent(assignment, studentId, isBilingual) {
  let studentManifest = getManifestForBilingualSetting(assignment.manifest, isBilingual);
  studentManifest = cleanManifest(studentManifest);

  const studentAssignment = {
    ...assignment,
    entityId: studentId,
    entityType: ENTITY_TYPE.STUDENT,
    parentId: assignment.assignmentId,
    manifest: studentManifest,
  };
  return await addAssignment(studentAssignment);
}

/**
 * creates a new assignment instance
 * @param assignment {object} - the new assignment to be created
 * @returns {Promise<*>}
 */
export async function addAssignment(assignment) {
  const response = await graphqlRequest(ADD_ASSIGNMENT, toAddAssignmentInput(assignment));
  const {addAssignment} = response;
  return addAssignment;
}

/**
 * transforms an assignment for input into assignment GraphQL mutation
 * @param assignment
 * @returns {AddAssignmentInput}
 */
export function toAddAssignmentInput(assignment){
  let {dateTo,dateFrom} = assignment;
  let dateToTransform, dateFromTransform;

  if(assignment.entityType !== ENTITY_TYPE.STUDENT){
    if(dateFrom){
      let fromDate = new Date(dateFrom)
      dateFromTransform = fromDate.toISOString().split('T')[0] + " 00:00:00"
    }

    if(dateTo){
      dateToTransform = moment(dateTo).endOf('day').format('YYYY-MM-DD HH:mm:ss');
    }
  }else{
    dateFrom = null;
    dateTo = null;
  }

  return {
    input: {
      assignmentType: assignment.assignmentType,
      assignor: assignment.assignor,
      dateFrom: dateFromTransform,
      dateTo: dateToTransform,
      entityId: assignment.entityId,
      entityType: assignment.entityType,
      parentId: assignment.parentId,
      manifest: toAssignmentManifestInput(assignment.manifest),
    }
  }
}

/**
 * transforms an assignment's manifest for input into assignment GraphQL mutation
 * @param manifest {array} - assignment manifest
 * @returns {array<AssignmentManifestInput>}
 */
export function toAssignmentManifestInput(manifest){
  return manifest.map(activity => {
    return {
      activityType: activity.activityType,
      locale: activity.locale,
      sequence: activity.sequence,
      storyId: activity.storyId,
    };
  });
}

/**
 * filters assignment manifest items by locale based on isBilingual
 * @param manifest {array} - assignment manifest
 * @param isBilingual {boolean} - student's isESL setting
 * @returns {array}
 */
export function getManifestForBilingualSetting(manifest, isBilingual){
  return isBilingual ? manifest : manifest.filter(activity => activity.locale === 'EN_US');
}
